export default __webpack_public_path__ + "static/media/marc.f1cdc0e0.jpg";